"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = GridClip;

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _uiKit = require("@devsta/ui-kit");

var _commonReact = require("@devsta/common-react");

var _onEnterPressed = _interopRequireDefault(require("@devsta/on-enter-pressed"));

var _PositionInput = _interopRequireDefault(require("./PositionInput"));

var _AssetTitle = _interopRequireDefault(require("../../../../../../../../../common/components/AssetTitle"));

require("../styles/_grid-clip.scss");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function withNoEventPropagation(fn) {
  return function (e) {
    e.preventDefault();
    e.stopPropagation();
    fn();
  };
}

function GridClip(_ref) {
  var selected = _ref.selected,
      onSelect = _ref.onSelect,
      index = _ref.index,
      clipsLength = _ref.clipsLength,
      onChangeIndex = _ref.onChangeIndex,
      onDragEnter = _ref.onDragEnter,
      asset = _ref.asset,
      canUpdateVideo = _ref.canUpdateVideo,
      commentsQuantity = _ref.commentsQuantity,
      onRemoveClip = _ref.onRemoveClip,
      assetId = _ref.assetId;
  return /*#__PURE__*/_react.default.createElement("div", {
    onClick: onSelect,
    className: (0, _classnames.default)('grid-clip', {
      'grid-clip--selected': selected,
      'grid-clip--disabled': !canUpdateVideo
    }),
    onDragEnter: onDragEnter,
    role: "button",
    tabIndex: 0,
    onFocus: onSelect,
    onKeyPress: (0, _onEnterPressed.default)({
      onClick: onSelect,
      allowPropagation: true
    })
  }, /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("div", {
    className: "grid-clip__top-content"
  }, /*#__PURE__*/_react.default.createElement(_PositionInput.default, {
    value: index + 1,
    onChange: onChangeIndex,
    clipsLength: clipsLength,
    canUpdateVideo: canUpdateVideo
  }), canUpdateVideo ? /*#__PURE__*/_react.default.createElement(_uiKit.Icon, {
    className: "grid-clip__top-content__delete",
    name: "trash",
    size: 15,
    color: "nevada",
    onClick: withNoEventPropagation(onRemoveClip),
    hoverColor: "redApple"
  }) : null, /*#__PURE__*/_react.default.createElement("div", {
    className: "grid-clip__top-content__comments"
  }, /*#__PURE__*/_react.default.createElement(_uiKit.Icon, {
    name: "comments",
    color: "regent",
    size: 15
  }), /*#__PURE__*/_react.default.createElement("p", null, commentsQuantity))), /*#__PURE__*/_react.default.createElement("div", {
    className: "grid-clip__bottom-content"
  }, /*#__PURE__*/_react.default.createElement(_commonReact.AssetPreview, {
    assetId: assetId,
    height: "100px",
    width: "100%",
    darkMode: true
  }), asset ? /*#__PURE__*/_react.default.createElement(_AssetTitle.default, {
    assetId: assetId
  }) : /*#__PURE__*/_react.default.createElement("div", {
    className: "grid-clip__bottom-content__title-placeholder"
  }))));
}